module.exports = __webpack_public_path__ + "img/carousel-3.bacbb5b3.png";